export const formConstants = {
  CREATE_FORMS: 'CREATE_FORMS',
  RETRIEVE_FORMS: 'RETRIEVE_PFORMS',
  UPDATE_FORMS: 'UPDATE_FORMS',
  DELETE_FORMS: 'DELETE_FORMS',
  DELETE_ALL_FORMS: 'DELETE_ALL_FORMS',
}
